module.exports = __webpack_public_path__ + "static/media/P1010320.555db666.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/client/shared/images/P1010320.JPG
// module id = 487
// module chunks = 0